import { render, staticRenderFns } from "./OpenPayPage.vue?vue&type=template&id=46755792&"
import script from "./OpenPayPage.vue?vue&type=script&lang=js&"
export * from "./OpenPayPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports